import React, { memo, useEffect, useMemo } from 'react'
import styles from './AdminHeader.module.scss'
import { useUserRole, useUserSelector } from '@store/selectors/auth'
import { AdminProfileDrop } from '@menu/dropdown/adminProfile/adminProfile'
import { Tabs } from 'antd'
import { useLocation } from 'react-router-dom'
import useCurrentTab from '../../../hooks/useCurrentTab'
import { adminTabs } from './adminTabs'
import HeaderLogo from '@components/ui/headerLogo/HeaderLogo'
import { EUserRoles } from '@enums/roles'
import { bossTabs } from '@components/Header/AdminHeader/bossTabs'
import { accountantTabs } from '@components/Header/AdminHeader/accountantTabs'
import { useAppDispatch } from '@store/hooks'
import { getPrice } from '@store/currency/thunk'
import useServerExpired from '@hooks/useServerExpired'
import { telephonyTabs } from '@components/Header/AdminHeader/telephonyTabs'

const AdminHeader: React.FC = memo(() => {
  const dispatch = useAppDispatch()
  const user = useUserSelector()
  const role = useUserRole()
  const { pathname } = useLocation()
  const activeTab = useCurrentTab(pathname)
  useServerExpired()

  useEffect(() => {
    dispatch(getPrice()).then()
  }, [])

  const items = useMemo(() => {
    switch (role) {
      case EUserRoles.SUPER_ADMIN: {
        return adminTabs.map((el, index) => ({ label: <>{el.title}</>, key: String(index) }))
      }
      case EUserRoles.BOSS: {
        return bossTabs.map((el, index) => ({ label: <>{el.title}</>, key: String(index) }))
      }
      case EUserRoles.ACCOUNTANT: {
        return accountantTabs.map((el, index) => ({ label: <>{el.title}</>, key: String(index) }))
      }
      case EUserRoles.PHONE_OPERATOR: {
        return telephonyTabs.map((el, index) => ({ label: <>{el.title}</>, key: String(index) }))
      }
    }
  }, [role])

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <span className={styles.logo}>
          <HeaderLogo />
        </span>
        {user && (
          <div className={styles.menu}>
            <div className={styles.dropdown}>
              <AdminProfileDrop />
            </div>
          </div>
        )}
      </div>
      <div className={styles.bottom}>
        <Tabs
          className={styles.tabs}
          defaultActiveKey='0'
          activeKey={String(activeTab)}
          items={items}
        />
      </div>
    </div>
  )
})

export default AdminHeader
